import { render, staticRenderFns } from "./MozInput.vue?vue&type=template&id=35b6655f&scoped=true&"
import script from "./MozInput.vue?vue&type=script&lang=js&"
export * from "./MozInput.vue?vue&type=script&lang=js&"
import style0 from "./MozInput.vue?vue&type=style&index=0&id=35b6655f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b6655f",
  null
  
)

export default component.exports